@if (welcomeMessage(); as welcome) {
    @let image = welcomeImage();
    <section
        class="welcome flex flex-col items-center text-center"
        [class.gap-2]="isPhone()"
        [class.gap-3]="!isPhone()"
        aria-label="Welcome to Quippy"
    >
        <img
            [class]="
                appearance() === 'outlined' || isPhone() ? '-mb-3' : '-mb-6'
            "
            [src]="image.src"
            [srcset]="image.srcset"
            [alt]="image.alt"
            [width]="image.width"
            [height]="image.height"
        />
        <p
            class="welcome-bubble m-0 max-w-xl bg-card px-5 py-4 text-body text-card"
            [class.shadow-xs]="appearance() === 'elevated'"
            [class.outlined]="appearance() === 'outlined'"
        >
            {{ welcome.content }}
        </p>
    </section>
}

@for (message of conversationMessages(); track message.id) {
    <article
        qpx-quippy-message-item
        [appearance]="appearance()"
        [message]="message"
        [isThreadLoading]="isThreadLoading()"
        [sourceFallbackBuildingId]="sourceFallbackBuildingId()"
        (retry)="retry.emit($event)"
        (editResend)="editResend.emit($event)"
        (documentOptionSelected)="documentOptionSelected.emit($event)"
    ></article>
}

@if (showPackOffer()) {
    <div class="pack-offer" role="group" aria-label="Document pack suggestion">
        <div class="pack-offer-content flex min-w-0 flex-col gap-1.5">
            <div
                class="pack-offer-bubble flex flex-col gap-2"
                [class.shadow-xs]="appearance() === 'elevated'"
                [class.outlined]="appearance() === 'outlined'"
            >
                <p qpxBody class="m-0">
                    Would you like me to prepare a document pack with these
                    documents?
                </p>
                <p qpxBody="secondary" tone="muted" class="m-0">
                    Review the sections, requirements and assigned documents
                    before creating it.
                </p>
                <div class="flex flex-wrap gap-2">
                    <button
                        qpxButton
                        matButton="outlined"
                        size="sm"
                        (click)="onPreparePack()"
                    >
                        Prepare a pack
                    </button>
                    <button
                        qpxButton
                        matButton
                        size="sm"
                        (click)="packOfferDismissed.set(true)"
                    >
                        Keep searching
                    </button>
                </div>
            </div>
            @if (packOfferTimestamp(); as timestamp) {
                <div class="flex h-4 items-center px-1">
                    <time
                        class="block text-button-xs font-normal text-muted"
                        [attr.datetime]="timestamp | qpxToLocalISO"
                    >
                        {{ timestamp | qpxRelativeDate: now() }}
                    </time>
                </div>
            }
        </div>
    </div>
}
